import {
  MicrophoneUnmutedIcon,
  MicrophoneMutedIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@rsos/assets/icons';
import { useDispatcherVideoContext } from '../../DispatcherVideoContext/useDispatcherVideoContext';
import { StyledButton, StyledSplitButton } from './DispatcherControls.styles';
import { MediaDeviceMenu } from './MediaDeviceMenuPlus';
import { usePreferredAudioDevices } from './usePreferredAudioDevices';

export const MuteButton = () => {
  const { muted, toggleMuted } = useDispatcherVideoContext();

  const {
    preferredAudioInputDeviceId,
    preferredAudioOutputDeviceId,
    setPreferredMediaDeviceId,
  } = usePreferredAudioDevices();

  return (
    <>
      <StyledSplitButton data-name="mute-dropdown-button">
        <StyledButton title={muted ? 'Unmute' : 'Mute'} onClick={toggleMuted}>
          {muted ? (
            <MicrophoneMutedIcon data-name="microphone-muted-icon" />
          ) : (
            <MicrophoneUnmutedIcon data-name="microphone-unmuted-icon" />
          )}
        </StyledButton>
        <MediaDeviceMenu
          kind={[
            {
              kind: 'audioinput',
              initialSelection: preferredAudioInputDeviceId,
            },
            {
              kind: 'audiooutput',
              initialSelection: preferredAudioOutputDeviceId,
            },
          ]}
          onActiveDeviceChange={(kind, deviceId) => {
            setPreferredMediaDeviceId(kind, deviceId);
          }}
        >
          {/* we use CSS to control which icon is visible, since the state of
          the menu is in MediaDeviceMenu and not exposed other than an attribute
          on MediaDeviceMenu's rendered HTML */}
          <ChevronUpIcon width={12} height={12} />
          <ChevronDownIcon width={12} height={12} />
        </MediaDeviceMenu>
      </StyledSplitButton>
    </>
  );
};
